import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React, { memo } from 'react';
import './LoadingOverlay.scss';

type LoadingOverlayProps = {
  visible: boolean;
  loadingText?: string;
};

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  visible,
  loadingText,
}) => {
  return (
    <div className="loading-overlay-container" hidden={!visible}>
      <div className="loading-overlay-content">
        <Spin indicator={LoadingIndicator} />
        {loadingText && (
          <p className="loading-overlay-loading-text">{loadingText}</p>
        )}
      </div>
    </div>
  );
};

const LoadingIndicator = (
  <Loading3QuartersOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export default memo(LoadingOverlay);
